import { BehaviorSubject } from "rxjs";
import { EventEmitter } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { IFilter } from "../services/IFilter";
import { AuthService } from "../services/auth.service";

export class ClassCodesFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

  codeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get code():any {
    return this.codeChange.value;
  }
  set code(value:any) {
    this.codeChange.next(value);
    this.emitChange("code", value);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(value:any) {
    this.nameChange.next(value);
    this.emitChange("name", value);
  }

  descriptionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get description():any {
    return this.descriptionChange.value;
  }
  set description(value:any) {
    this.descriptionChange.next(value);
    this.emitChange("description", value);
  }

  activeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get active():any {
    return this.activeChange.value;
  }
  set active(value:any) {
    this.activeChange.next(value);
    this.emitChange("active", value);
  }

  notesChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get notes():any {
    return this.notesChange.value;
  }
  set notes(value:any) {
    this.notesChange.next(value);
    this.emitChange("notes", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.code && this.code !== '') {
      params = params.set("code", this.code);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.description && this.description !== '') {
      params = params.set("description", this.description);
    }
    if (this.active && this.active !== '') {
      params = params.set("active", this.active);
    }
    if (this.notes && this.notes !== '') {
      params = params.set("notes", this.notes);
    }

    return params;
  }

  setFilters(props: any): void {
    this.codeChange.next(props.code || undefined);
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.descriptionChange.next(props.description || undefined);
    this.activeChange.next(props.active || undefined);
    this.notesChange.next(props.notes || undefined);
  }

  toObj() {
    let obj:any = {};

    obj.code = this.code;
    obj.companyId = this.companyId;
    obj.name = this.name;
    obj.description = this.description;
    obj.active = this.active;
    obj.notes = this.notes;
 
    return obj;
  }

  public clear():void {
    this.code = undefined;
    this.companyId = this.auth.getCompanyId();
    this.name = undefined;
    this.description = undefined;
    this.active = undefined;
    this.notes = undefined;
  }
}
